interface TableProps {
  children: JSX.Element | JSX.Element[]
  className?: string
}

const Table = ({ children, className = '' }: TableProps) => (
  <div className={`px-4 bg-white w-full rounded-lg flex mb-4 ${className}`}>
    <ul className='w-full'>{children}</ul>
  </div>
)

export default Table
